import { Routes } from '@angular/router';
import { PatientEditMode } from '@core/enums/patient-edit-mode.enum';
import { PatientEditComponent } from '../../../../../core/components/patient/patient-edit/patient-edit.component';
import { PatientMainComponent } from './patient-main.component';

export const patientMainRoutes: Routes = [
  {
    path: '',
    component: PatientMainComponent,
  },
  {
    path: 'add',
    component: PatientEditComponent,
    data: { mode: PatientEditMode.family },
  },
  {
    path: 'edit/:id',
    component: PatientEditComponent,
    data: { mode: PatientEditMode.family },
  },
];
